import { Hints, adaptiveTextGroups } from "../../components/ui";

export const GridColumnHeaderText = ({ text }: { text: string }) => (
  <Hints
    text={text}
    variant="label"
    adaptiveText={{
      group: adaptiveTextGroups.gridColumnHeaders,
      maxLines: 3,
    }}
    sx={{
      color: "inherit",
      fontWeight: "inherit",
      maxWidth: "100%",
      textAlign: "inherit",
    }}
  />
);
